import { axiosGet, axiosPost } from "@/services/axiosService";
import { useQueries } from "@tanstack/react-query";

export const useGetCategories = ({
  selectedBot,
  selectedFilter = "all",
  page = 1,
  pageSize = 10,
  hidePagination,
  searchString,
}) => {
  const botCustomId = selectedBot?.botCustomId;

  const queries = useQueries({
    queries: [
      {
        queryKey: [
          "getCategories",
          botCustomId,
          selectedFilter,
          page,
          pageSize,
          searchString,
        ],
        queryFn: () => {
          return axiosPost("/analysis/getCategories", {
            botCustomId: selectedBot.botCustomId,
            selectedFilter: selectedFilter,
            page: page,
            pageSize: pageSize,
            searchString,
          });
        },
        select: (response: any) => response.data,
        enabled: !!botCustomId && !!selectedFilter && !hidePagination,
      },
    ],
  });
  const responseData = queries[0].data as any;

  return {
    categories: responseData?.categories,
    categoryPagination: responseData?.pagination,
    isLoading: queries.some((query) => query.isLoading),
    isFetching: queries.some((query) => query.isFetching),
    isError: queries.some((query) => query.isError),
    refetch: queries[0].refetch,
    error: queries.find((query) => query.isError)?.error,
  };
};
